<template>
  <div class="common-header">
    <div class="left-content">
      <el-button class="menu-button" size="medium" :icon="collapseButtonIcon" :title="collapseButtonTitle" @click="handleMenu"></el-button>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.path" :to="clickBreadCrumb(item)">{{ item.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right-content">
      <el-dropdown trigger="click" size="medium">
        <span>
          <el-avatar :size="40" :src="avatar" :title="userName"></el-avatar>
          <el-dropdown-menu slot="dropdown">
            <div style="text-align: center; margin: 10px; color: #0077aa">{{ userName }}</div>
            <el-dropdown-item @click.native="linkTo('/space')">个人中心</el-dropdown-item>
            <!--给组件添加事件，需要使用native-->
            <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </span>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "CommonHeader",
  data() {
    return {
      // userName: '管理员',
      // avatar: require('../assets/imgs/avatar.png')
    }
  },
  mounted() {
    // console.log('mounted bread',this.$store.state.header.breadcrumbList)
  },
  methods: {
    linkTo(path, query) {
      this.$router.push({
        path: path,
        query: query
      })
    },
    handleMenu() {
      this.$store.commit('aside/handleMenu')
    },
    // 点击面包屑跳转
    clickBreadCrumb(item) {
      // 只有当item的path不为空，且和当前路由的path不同才触发跳转
      if (item.path !== '' && item.path !== this.currentRoute.path) {
        return {
          path: item.path,
          // replace: true
        }
      }
    },
    logout: function () {
      this.$confirm('确定要退出登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.commit('user/logout')
        this.$router.replace('/login')
        this.$message({
          type: 'success',
          message: '已退出登录!'
        });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    }
  },
  computed: {
    // 下面的操作全部放到state中
    /*isCollapse() {
      return this.$store.state.aside.isCollapse
    },
    handleMenuButtonIcon() {
      return this.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
    },
    handleMenuButtonTitle() {
      return this.isCollapse ? '展开菜单' : '收起菜单'
    }*/
    ...mapState('aside',["collapseButtonIcon", "collapseButtonTitle"]),
    // 面包屑数据
    breadcrumbList() {
      return this.$store.state.header.breadcrumbList
    },
    ...mapState('header',['currentRoute']),
    userName() {
      const name = this.$store.state.user.Authorization.name
      const nickName = this.$store.state.user.Authorization.nickName
      return nickName ? nickName : (name ? name : '管理员')
    },
    avatar() {
      const a = this.$store.state.user.Authorization.avatar
      return a ? a : require('../assets/imgs/avatar.png')
    }
  },
  watch: {
    $route: {
      handler: function(route) {
        // console.log('=====watch===',route)
        this.$store.commit('header/handleCurrentRoute', route)
        // 同时去处理面包屑
        this.$store.commit('header/handleBreadCrumb', route)
        // 处理tag
        this.$store.commit('header/addTag', route)
      },
      immediate: true
    }
  },

}
</script>

<style lang="less" scoped>
  .common-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    height: 100%;
    background-color: #515f61;
    .left-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .menu-button {
      padding: 3px;
      margin-left: 10px;
      margin-right: 10px;
    }
    .el-avatar {
      margin-right: 20px;
      cursor: pointer;
    }
  }
  /* 面包屑不被选中时的颜色 */
  .el-breadcrumb :deep(.el-breadcrumb__inner) {
    color: #e1e1e1 !important;
    font-weight:400 !important;
  }
  /* 被选中时的颜色 */
  .el-breadcrumb__item:last-child :deep(.el-breadcrumb__inner) {
    color: #ffffff !important;
    font-weight:800 !important;
  }
</style>
